import { useState, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { isNil } from "ramda";
import { Box, Typography, LinearProgress } from "@mui/material";

import { deserializeFunction } from "utils/storeUtils";
import loader from "assets/images/hamster.gif";
import { mobileDebugOn } from "utils/logUtils";

import { StyledDialog, StyledPaper, Image, ModalMessage, Message } from "./styles";

const LoadingModal = ({ labelFunc, progress }) => {
  const [seconds, setSeconds] = useState(0);
  const addSecond = () => setSeconds((prevSeconds) => prevSeconds + 1);

  useEffect(() => {
    const interval = setInterval(addSecond, 1000);
    return () => clearInterval(interval);
  }, [labelFunc]);

  const getLabel = useMemo(() => labelFunc && deserializeFunction(labelFunc), [labelFunc]);

  const getMessage = () => {
    if (getLabel) return getLabel(seconds);
    return "Loading";
  };

  const message = getMessage();

  const renderProgress = () => {
    const percent = Math.round(progress * 100);

    return (
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Box sx={{ width: "100%", mr: 1 }}>
          <LinearProgress variant="determinate" value={percent} />
        </Box>
        <Box sx={{ minWidth: 35 }}>
          <Typography variant="large">{`${percent}%`}</Typography>
        </Box>
      </Box>
    );
  };

  return (
    <StyledDialog disableScrollLock={mobileDebugOn()} open PaperComponent={StyledPaper} data-testid="loadingmodal">
      <Image src={loader} alt="loader" />
      <ModalMessage>
        <Message variant="h2" fontWeight="Regular">
          {message}
        </Message>
      </ModalMessage>
      {!isNil(progress) && renderProgress()}
    </StyledDialog>
  );
};

LoadingModal.propTypes = {
  labelFunc: PropTypes.string,
  progress: PropTypes.number,
};

export default LoadingModal;
